import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useQuill } from 'react-quilljs'
import { useNavigate } from 'react-router-dom'
import {
  LoadAllTemoignageId,
  LoadAllTemoignageIdPUT,
  UpdateTemoignageAction,
} from '../../../actions/Temoignages/TemoignageAction'
import AllRoutes from '../../../nametitle/AllRoutes'
import { baseUrl } from '../../../nametitle/dataUrl'
import { Localvalue } from '../../../nametitle/localValue'

const UpdateTemoignagePage = () => {
  const navigate = useNavigate()
  var idT = localStorage.getItem(Localvalue.idTemoignage);
  var contentT = localStorage.getItem(Localvalue.contentBlog);

  
  const [title, settitle] = useState();
  const [description, setdescription] = useState();
  const [coverPicture, setcoverPicture] = useState();
  const [video, setvideo] = useState();
  const [audio, setaudio] = useState();
  const [content, setcontent] = useState(contentT);
  const [disable,  setdisable]= useState();

  const { quill, quillRef } = useQuill()

  const [temoinget, settemoiget] = useState([])
  useEffect(() => {
    LoadAllTemoignageIdPUT(idT,settitle,setcoverPicture,setdescription,setcontent,setvideo,setaudio);
    LoadAllTemoignageId(idT,settitle,setcoverPicture,setcontent,setvideo,setaudio,setdescription);
  }, []);
  useEffect(() => {
    if (quill) {
      quill.clipboard.dangerouslyPasteHTML(`${content}`);
    }
  }, [quill])
  // ************************************************Photo
  const [Loading, setLoading]= useState();
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader(); fileReader.readAsDataURL(file); fileReader.onload = () => { resolve(fileReader.result); };
      fileReader.onerror = (error) => { reject(error); };
    });
  }
  function uploadSinglePhoto(base64) {
    setLoading(true);
    axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then((res) => { setcoverPicture(res.data); alert("image uploaded Succesfully"); })
      .then(() => setLoading(false))
      .catch(console.log);
  }
  const HandleFileInputChangePhoto = async (event) => {
    const files = event.target.files;
    console.log(files.length);
    if (files.length === 1) {
      const base64 = await convertBase64(files[0]);
      uploadSinglePhoto(base64); return;
    }
    const base64s = [];
    for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
  };
  // **************************************************Vidéo
  function uploadSingleVideo(base64) {
    setLoading(true);
    axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then((res) => { setvideo(res.data); alert("image uploaded Succesfully"); })
      .then(() => setLoading(false))
      .catch(console.log);
  }
  const HandleFileInputChangeVideo = async (event) => {
    const files = event.target.files;
    console.log(files.length);
    if (files.length === 1) {
      const base64 = await convertBase64(files[0]);
      uploadSingleVideo(base64); return;
    }
    const base64s = [];
    for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
  };
  // ***************************************************Audio
  function uploadSingleAudio(base64) {
    setLoading(true);
    axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then((res) => { setaudio(res.data); alert("image uploaded Succesfully"); })
      .then(() => setLoading(false))
      .catch(console.log);
  }
  const HandleFileInputChangeAudio = async (event) => {
    const files = event.target.files;
    console.log(files.length);
    if (files.length === 1) {
      const base64 = await convertBase64(files[0]);
      uploadSingleAudio(base64); return;
    }
    const base64s = [];
    for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
  };

  
  
  
  function Text (){
    if(quill){
      setcontent(quill.root.innerHTML);
      console.log(content);
    }else{
      return ;
    }
  }


  return (
    <div>
      <div className="translatable pt-4 pb-2">
        <div className="translatable w-full flex justify-center ">

          <a href={`/${AllRoutes.admin}/${AllRoutes.temoins}`}>
            <button className="translatable btn btn-outline-primary py-2" type="submit">retour</button>
          </a>
          <h2 className="translatable w-full text-2xl ">Rédiger votre temoignage</h2>
        </div>
      </div>
      <div>
        <div className="translatable flex justify-center row g-8 h-[750px]">
          <div className="translatable col-lg-9">
            <form className="translatable pb-6"
              onSubmit={(e) => {
                if (content == "") {
                  alert("remplissez les contenu la partie redaction ! ");
                } else {
                  e.preventDefault();
                  UpdateTemoignageAction(idT,title, coverPicture, description, content, video, audio, navigate);
                }
              }} >
              <div className="translatable row g-3">
                <div className="translatable col-12">
                  <label className="translatable text-xl">Titre de de votre témoignage *</label>
                  <input value={title} onChange={(e) => { settitle(e.target.value) }} type="text"  className="translatable form-control bg-light border-0 px-4 py-2" placeholder="titre" style={{ height: "55px" }} />
                </div>
                <div className="translatable col-12 flex space-x-3">
                  <label className="translatable text-xl">Photo *</label>
                  <input type="file"  className="translatable form-controlt border-0 px-4 " onChange={HandleFileInputChangePhoto} accept={`.JPG,.PNG,.JPEG`} placeholder="Nom Complet" />
                  {
                    coverPicture && (<img src={coverPicture} className="translatable h-[50px] w-[50px]" />)
                  }
                </div>
                <div className="translatable col-12 flex space-x-3">
                  <label className="translatable text-xl">vidéo *</label>
                  <input type="file"  className="translatable form-controlt border-0 px-4 " onChange={HandleFileInputChangeVideo} accept={`.MP4`} placeholder="Nom Complet" />
                  {
                    video && (<label className="translatable text-green-600" >vidéo télécharger</label>)
                  }
                </div>
                <div className="translatable col-12 flex space-x-3">
                  <label className="translatable text-xl">audio *</label>
                  <input type="file"  className="translatable form-controlt border-0 px-4 " onChange={HandleFileInputChangeAudio} accept={`.MP3`} placeholder="Nom Complet" />
                  {
                    audio && (<label className="translatable text-green-600" >audio télécharger</label>)
                  }
                </div>
                <div className="translatable col-12">
                  <label className="translatable text-xl">description *</label>
                  <textarea value={description} onChange={(e) => { setdescription(e.target.value) }} required className="translatable form-control bg-light border-0 px-4" placeholder="Ajouter une description" style={{ height: "55px" }} />
                </div>
                <div className="translatable col-12">
                  <label className="translatable text-xl">redaction *</label>
                  <div className="translatable w-full h-[200px]" >
                    <div ref={quillRef} />
                  </div>
                </div>
                <div className="translatable col-12 mt-5 py-5">
                  <button class={`btn  btn-outline-primary  ${disable} w-100 py-3`} onClick={Text} type="submit">Publier</button>
                </div>
                {/*
                <div className="translatable col-12 mt-5 py-5" onClick={()=>{var  text = quill.root.innerHTML;console.log(text);}}>
                  <button class={`btn  btn-outline-primary  ${disable} w-100 py-3`} type="button">test</button></div>
                 */}
              </div>
            </form>
          </div>
        </div>
      </div>


    </div>
  )
}

export default UpdateTemoignagePage
